import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemAwarenessSection } from '../components/ProblemAwarenessSection';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductInUseSection } from '../components/ProductInUseSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCloseSection } from '../components/FinalCloseSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans text-gray-900 selection:bg-blue-100" data-id="element-355">
      <HeroSection data-id="element-356" />
      <ProblemAwarenessSection data-id="element-357" />
      <DifferentiationSection data-id="element-358" />
      <MechanismSection data-id="element-359" />
      <ProductInUseSection data-id="element-360" />
      <BenefitsSection data-id="element-361" />
      <TestimonialsSection data-id="element-362" />
      <PricingSection data-id="element-363" />
      <GuaranteeSection data-id="element-364" />
      <FAQSection data-id="element-365" />
      <FinalCloseSection data-id="element-366" />
      <Footer data-id="element-367" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_10px_-1px_rgba(0,0,0,0.05)] md:hidden z-50" data-id="element-368">
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full bg-[#1E40AF] text-white font-bold py-3.5 px-6 rounded-full shadow-lg active:scale-95 transition-transform" data-id="element-369">
          I Want Quiet Nights Back
        </button>
      </div>
    </div>;
}